import React from "react";
import { Icon } from "../../Component";

const MedicalPartnerListTabs = ({ activeTab, setActiveTab, setCurrentPage, stats }) => (
  <div className="card-inner border-bottom">
    <ul className="nav nav-tabs nav-tabs-mb-icon">
      <li className="nav-item">
        <button
          type="button"
          className={`nav-link ${activeTab === "pending" ? "active" : ""}`}
          onClick={() => {
            setActiveTab("pending");
            setCurrentPage(1);
          }}
          style={{ border: "none", background: "none", padding: "12px 16px", cursor: "pointer" }}
        >
          <Icon name="clock" />
          <span>Pending requests</span>
          {stats.pending > 0 ? <span className="badge bg-warning ms-2">{stats.pending}</span> : null}
        </button>
      </li>
      <li className="nav-item">
        <button
          type="button"
          className={`nav-link ${activeTab === "active" ? "active" : ""}`}
          onClick={() => {
            setActiveTab("active");
            setCurrentPage(1);
          }}
          style={{ border: "none", background: "none", padding: "12px 16px", cursor: "pointer" }}
        >
          <Icon name="check-circle" />
          <span>Live partners</span>
          {stats.active > 0 ? <span className="badge bg-success ms-2">{stats.active}</span> : null}
        </button>
      </li>
      <li className="nav-item">
        <button
          type="button"
          className={`nav-link ${activeTab === "all" ? "active" : ""}`}
          onClick={() => {
            setActiveTab("all");
            setCurrentPage(1);
          }}
          style={{ border: "none", background: "none", padding: "12px 16px", cursor: "pointer" }}
        >
          <Icon name="users" />
          <span>All partners</span>
        </button>
      </li>
    </ul>
  </div>
);

export default MedicalPartnerListTabs;
